// components/list/ListGenerationTelemetry.tsx
'use client';
import { memo, useEffect, useState } from 'react';
import type { GenerationTask } from '#types/types';
import { listGenerationStatus } from '#lib/list/listGenerationTelemetry';
import { resolveRegistryModelIdFromRuntimeName, STUDIO_MODEL_REGISTRY, type StudioModelId } from '#lib/model-registry';

export const ListGenerationTelemetry = memo(function ListGenerationTelemetry({ tasks }: { tasks: GenerationTask[] }) {
  const [now, setNow] = useState(() => Date.now());
  const active = tasks.length > 0;
  useEffect(() => {
    if (!active) return;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [active]);
  if (!active) return null;
  return <div className="w-full space-y-2 py-1 text-[11px] leading-relaxed" aria-label="Generation status">
    {tasks.map(task => {
      const status = listGenerationStatus(task, now);
      const modelId = resolveRegistryModelIdFromRuntimeName(task.model);
      const model = modelId ? STUDIO_MODEL_REGISTRY[modelId as StudioModelId]?.name ?? task.model : task.model;
      const startedAt = task.listAttempt?.startedAt ?? task.startedAt;
      const elapsed = startedAt ? Math.max(0, Math.floor((now - startedAt) / 1000)) : null;
      return <div key={task.id} data-generation-status={task.id} className="border-l border-white/15 pl-2">
        <span className="text-white/75">{status.phase}</span>
        <span className="text-white/45"> · {model}{elapsed !== null ? ` · ${Math.floor(elapsed / 60)}:${String(elapsed % 60).padStart(2, '0')}` : ''}</span>
      </div>;
    })}
  </div>;
});
